// Top 50 world currencies with their symbols and codes

export const CURRENCIES = [
    { code: 'USD', name: 'US Dollar', symbol: '$', country: 'United States' },
    { code: 'EUR', name: 'Euro', symbol: '€', country: 'European Union' },
    { code: 'GBP', name: 'British Pound', symbol: '£', country: 'United Kingdom' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥', country: 'Japan' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', country: 'China' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', country: 'Australia' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', country: 'Canada' },
    { code: 'CHF', name: 'Swiss Franc', symbol: 'Fr', country: 'Switzerland' },
    { code: 'INR', name: 'Indian Rupee', symbol: '₹', country: 'India' },
    { code: 'PKR', name: 'Pakistani Rupee', symbol: '₨', country: 'Pakistan' },
    { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', country: 'Brazil' },
    { code: 'RUB', name: 'Russian Ruble', symbol: '₽', country: 'Russia' },
    { code: 'KRW', name: 'South Korean Won', symbol: '₩', country: 'South Korea' },
    { code: 'MXN', name: 'Mexican Peso', symbol: '$', country: 'Mexico' },
    { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', country: 'Indonesia' },
    { code: 'TRY', name: 'Turkish Lira', symbol: '₺', country: 'Turkey' },
    { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', country: 'Saudi Arabia' },
    { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', country: 'United Arab Emirates' },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R', country: 'South Africa' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', country: 'Singapore' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', country: 'Hong Kong' },
    { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', country: 'Sweden' },
    { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', country: 'Norway' },
    { code: 'DKK', name: 'Danish Krone', symbol: 'kr', country: 'Denmark' },
    { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', country: 'Poland' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿', country: 'Thailand' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', country: 'Malaysia' },
    { code: 'PHP', name: 'Philippine Peso', symbol: '₱', country: 'Philippines' },
    { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč', country: 'Czech Republic' },
    { code: 'ILS', name: 'Israeli Shekel', symbol: '₪', country: 'Israel' },
    { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', country: 'New Zealand' },
    { code: 'CLP', name: 'Chilean Peso', symbol: '$', country: 'Chile' },
    { code: 'TWD', name: 'Taiwan Dollar', symbol: 'NT$', country: 'Taiwan' },
    { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft', country: 'Hungary' },
    { code: 'EGP', name: 'Egyptian Pound', symbol: '£', country: 'Egypt' },
    { code: 'NGN', name: 'Nigerian Naira', symbol: '₦', country: 'Nigeria' },
    { code: 'VND', name: 'Vietnamese Dong', symbol: '₫', country: 'Vietnam' },
    { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳', country: 'Bangladesh' },
    { code: 'ARS', name: 'Argentine Peso', symbol: '$', country: 'Argentina' },
    { code: 'COP', name: 'Colombian Peso', symbol: '$', country: 'Colombia' },
    { code: 'PEN', name: 'Peruvian Sol', symbol: 'S/', country: 'Peru' },
    { code: 'RON', name: 'Romanian Leu', symbol: 'lei', country: 'Romania' },
    { code: 'QAR', name: 'Qatari Riyal', symbol: '﷼', country: 'Qatar' },
    { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', country: 'Kuwait' },
    { code: 'OMR', name: 'Omani Rial', symbol: '﷼', country: 'Oman' },
    { code: 'BHD', name: 'Bahraini Dinar', symbol: 'د.ب', country: 'Bahrain' },
    { code: 'JOD', name: 'Jordanian Dinar', symbol: 'د.ا', country: 'Jordan' },
    { code: 'LKR', name: 'Sri Lankan Rupee', symbol: '₨', country: 'Sri Lanka' },
    { code: 'UAH', name: 'Ukrainian Hryvnia', symbol: '₴', country: 'Ukraine' },
    { code: 'KES', name: 'Kenyan Shilling', symbol: 'KSh', country: 'Kenya' }
];

// Country to currency mapping for auto-detection
export const COUNTRY_TO_CURRENCY = {
    'US': 'USD',
    'GB': 'GBP',
    'EU': 'EUR',
    'JP': 'JPY',
    'CN': 'CNY',
    'AU': 'AUD',
    'CA': 'CAD',
    'CH': 'CHF',
    'IN': 'INR',
    'PK': 'PKR',
    'BR': 'BRL',
    'RU': 'RUB',
    'KR': 'KRW',
    'MX': 'MXN',
    'ID': 'IDR',
    'TR': 'TRY',
    'SA': 'SAR',
    'AE': 'AED',
    'ZA': 'ZAR',
    'SG': 'SGD',
    'HK': 'HKD',
    'SE': 'SEK',
    'NO': 'NOK',
    'DK': 'DKK',
    'PL': 'PLN',
    'TH': 'THB',
    'MY': 'MYR',
    'PH': 'PHP',
    'CZ': 'CZK',
    'IL': 'ILS',
    'NZ': 'NZD',
    'CL': 'CLP',
    'TW': 'TWD',
    'HU': 'HUF',
    'EG': 'EGP',
    'NG': 'NGN',
    'VN': 'VND',
    'BD': 'BDT',
    'AR': 'ARS',
    'CO': 'COP',
    'PE': 'PEN',
    'RO': 'RON',
    'QA': 'QAR',
    'KW': 'KWD',
    'OM': 'OMR',
    'BH': 'BHD',
    'JO': 'JOD',
    'LK': 'LKR',
    'UA': 'UAH',
    'KE': 'KES'
};

const STORAGE_KEY_CURRENCY = 'finance_app_currency';
const STORAGE_KEY_SHOW_CURRENCY = 'finance_app_show_currency';

// Get currency from localStorage or auto-detect
export const getDefaultCurrency = () => {
    // Check if user has previously selected a currency
    const savedCurrency = localStorage.getItem(STORAGE_KEY_CURRENCY);
    if (savedCurrency) {
        return savedCurrency;
    }

    // Auto-detect based on browser locale
    try {
        const locale = navigator.language || 'en-US';
        const region = locale.split('-')[1]; // e.g., 'US' from 'en-US'

        if (region && COUNTRY_TO_CURRENCY[region]) {
            return COUNTRY_TO_CURRENCY[region];
        }

        // Try to detect from timezone
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timeZone) {
            // Simple mapping based on common timezones
            if (timeZone.includes('Europe')) return 'EUR';
            if (timeZone.includes('America/New_York')) return 'USD';
            if (timeZone.includes('Asia/Karachi')) return 'PKR';
            if (timeZone.includes('Asia/Kolkata')) return 'INR';
            if (timeZone.includes('Asia/Tokyo')) return 'JPY';
            if (timeZone.includes('Australia')) return 'AUD';
        }
    } catch (error) {
        console.error('Error detecting currency:', error);
    }

    // Default to USD if detection fails
    return 'USD';
};

// Get show currency preference
export const getShowCurrencyPreference = () => {
    const saved = localStorage.getItem(STORAGE_KEY_SHOW_CURRENCY);
    return saved === null ? true : saved === 'true'; // Default to true
};

// Save currency preference
export const saveCurrency = (currencyCode) => {
    localStorage.setItem(STORAGE_KEY_CURRENCY, currencyCode);
};

// Save show currency preference
export const saveShowCurrencyPreference = (show) => {
    localStorage.setItem(STORAGE_KEY_SHOW_CURRENCY, show.toString());
};

// Get currency object by code
export const getCurrencyByCode = (code) => {
    return CURRENCIES.find(c => c.code === code) || CURRENCIES[0]; // Default to USD
};

// Format amount with currency
export const formatCurrency = (amount, currencyCode, showCurrency = true, showAmounts = true) => {
    if (!showAmounts) {
        return '****';
    }

    const currency = getCurrencyByCode(currencyCode);
    const formattedAmount = amount.toFixed(2);

    if (!showCurrency) {
        return formattedAmount;
    }

    // If symbol exists, use it, otherwise use code
    if (currency.symbol) {
        return `${currency.symbol}${formattedAmount}`;
    } else {
        return `${currency.code} ${formattedAmount}`;
    }
};
